import { render, staticRenderFns } from "./InterestsRegistryList.vue?vue&type=template&id=610473fa"
import script from "./InterestsRegistryList.vue?vue&type=script&lang=js"
export * from "./InterestsRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports